
<div class="tw-w-72 tw-mx-auto tw-my-10">
  <h2 class="mb-0">Add Bank Account</h2>
  <form [formGroup]="form" (ngSubmit)="onSubmit(model)">
    <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    <div style="display: flex; justify-content: flex-end" [ngClass]="{ 'progress-button--working': saving, 'progress-button': true }">
      <span *ngIf="showCancel">
        <button *ngIf="!saving" mat-flat-button type="button" (click)="onCancel()" style="color: #02c0ee;">Cancel</button>
        <button *ngIf="saving" mat-button disabled>Cancel</button>
      </span>
      <button mat-flat-button type="submit" color="primary" [disabled]="!form.valid || saving">
        <span class="progress-button-text">Save</span>
        <mat-spinner class="progress-button-spinner" diameter="24"></mat-spinner>
      </button>
    </div>
  </form>
</div>
